module.exports = __webpack_public_path__ + "static/media/54.b2be434b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/54.png
// module id = 479
// module chunks = 0